import React from "react";
import { makeStyles } from "@material-ui/core";
import { animated, useSpring } from "react-spring";
import { tesaBlue, tesaGrey1 } from "../../../styles/colors";
import { fadeIn } from "../../../styles/springs";
import { dashToSlash } from "../../../api/services/common/FormatDateService";

const useStyles = makeStyles({
  root: (props: CommentHeaderProps) => ({
    color: props.updateNotification ? tesaBlue : tesaGrey1,
    fontSize: "0.75rem",
  }),
});
interface CommentHeaderProps {
  date: Date;
  updateNotification?: boolean;
  username: string;
  time: string;
}

const CommentHeader = (props: CommentHeaderProps) => {
  const { date, updateNotification, username, time } = props;
  const classes = useStyles(props);

  const springPropsFadeIn = useSpring(fadeIn);

  return (
    <div className={classes.root}>
      <span>{username}</span>
      <span> | </span>
      <span>{dashToSlash(date.toISOString())}</span>
      <span> | </span>
      <span>{time}</span>
      {updateNotification && (
        <animated.span style={springPropsFadeIn}>
          <span> | </span>
          <span>SAVED</span>
        </animated.span>
      )}
    </div>
  );
};

export default CommentHeader;
